<template>
  <header class="section__header">
    <div class="circulo">
      <img width="60px" src="static/images/elipse.png" />
    </div>
    <div class="menu" @click="toggleSidenav(true)">
      <img width="32px" src="static/images/menu_toggle.png" />
    </div>
    <div class="logo">
      <img width="120px" src="static/images/claro_logo-white.png" />
    </div>
    <div class="tacha" @click="goHome">
      <img  width="32px" src="static/images/homeicon.png" />
    </div>
  </header>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ClaroHeader',
  methods: {
    ...mapActions([
      'toggleSidenav',
      'resetClientValues',
      'resetPurchaseValues'
    ]),
    goHome() {
      this.resetClientValues();
      this.resetPurchaseValues();
      global.router.push({ path: '/' });
    }
  }
};
</script>

<style lang="scss">
 
</style>



// WEBPACK FOOTER //
// src/components/Header.vue